import {
  HeartPulse, ClipboardList, ListChecks, FileCheck2, HeartHandshake, CalendarCheck, Landmark, Target, NotebookPen, Timer,
  CalendarRange, SearchCheck,
} from "lucide-react";

export const SUPPORTING = ["SENDCOs", "Inclusion Leads", "Headteachers", "Senior Leaders", "Governors"];

export const INCLUDED = [
  ["SENDCO Health Check", HeartPulse], ["SEND Provision Review", ClipboardList], ["SEND Register Health Review", ListChecks],
  ["EHCP Annual Review Toolkit", FileCheck2], ["Parent Partnership Reflection Tool", HeartHandshake], ["Attendance & Inclusion Review", CalendarCheck],
  ["Governor Challenge Questions", Landmark], ["SEND Action Planner", Target], ["SEND Improvement Journal", NotebookPen],
  ["30-Day SEND Sprint Planner", Timer], ["90-Day Improvement Planner", CalendarRange], ["Inspection Findings to Action Planning", SearchCheck],
];

export const SUPPORTS = ["Improve SEND Leadership", "Strengthen Parent Partnership", "Review SEND Provision", "Support Strategic Planning",
  "Monitor Improvement Activity", "Prepare for SEND Reviews", "Turn Inspection Findings into Action", "Support Governance Discussions",
  "Improve Outcomes for Children and Young People"];

export const ALIGNED = ["Children and Families Act 2014", "SEND Code of Practice", "SEND Regulations 2014", "Equality Act 2010", "UK GDPR",
  "Data Protection Act 2018", "Teachers' Standards", "Education Inspection Framework", "Area SEND Inspection Framework",
  "Keeping Children Safe in Education", "Working Together to Safeguard Children", "Working Together to Improve School Attendance",
  "Alternative Provision Guidance"];

export const ACCESS = ["High Contrast Design", "Screen Reader Friendly", "Accessible PDF Structure", "Keyboard Accessible", "Plain English",
  "Fillable Fields", "Saveable and Reusable", "Print Friendly"];

export const PLANNING = ["30-Day SEND Sprint Planning", "90-Day Improvement Planning", "Action Tracking", "SEND Improvement Journal",
  "Strategic Improvement Planning", "Evidence and Impact Planning", "Inspection-to-Action Framework"];

export const IMPACT = ["Downloads", "Feedback Received", "Actions Implemented", "Improvements Reported", "Recommendation Rates",
  "Potential Case Studies", "Future Resource Requests", "Admin Analytics Dashboard"];

export const STATUS_V1 = ["Workbook Content Complete", "Accessibility Included", "Legislative References Included", "GDPR Guidance Included",
  "Impact Tracking Included", "Feedback Framework Included", "Ready for Download"];
